import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LinkedInIcon, MailFilledIcon, WhatsAppIcon } from './SocialIcons';
import { navLinks } from '../data/navigation';
import { contact } from '../data/contact';
const iconLinks = [{
  label: 'Auf WhatsApp chatten',
  href: `https://wa.me/${contact.whatsappNumber}`,
  external: true,
  icon: <WhatsAppIcon className="h-[21px] w-[21px]" data-id="element-407" data-mp="1fxl12iwd3j5q" />
}, {
  label: 'LinkedIn-Profil',
  href: contact.linkedinUrl,
  external: true,
  icon: <LinkedInIcon className="h-[20px] w-[20px]" data-id="element-408" data-mp="1pp8om8pssg1x" />
}, {
  label: `E-Mail an ${contact.email}`,
  href: `mailto:${contact.email}`,
  external: false,
  icon: <MailFilledIcon className="h-[22px] w-[22px]" data-id="element-409" data-mp="1yq6tet828rlk" />
}];
export function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="relative z-40 bg-white" data-id="element-410" data-mp="23q1kawru5h6m">
      <div className="px-4 md:px-6" data-id="element-411" data-mp="1y5ymxl5rdiv5">
        <nav aria-label="Hauptnavigation" className="mx-auto flex h-[88px] max-w-[1360px] items-center justify-between border-x border-rail px-5 md:px-6" data-id="element-412" data-mp="1y66xv7ibme3p">
          <div className="flex items-center gap-16" data-id="element-413" data-mp="1p4qq77iw4q36">
            <a href="/" aria-label="Konrad Walz – Startseite" className="text-[24px] text-ink" data-id="element-414" data-mp="1p7cvt1m80vir">
              <Logo data-id="element-415" data-mp="1k80d8t2dualz" />
            </a>
            <ul className="hidden items-center gap-10 lg:flex" data-id="element-416" data-mp="2hto6j53jkcta">
              {navLinks.map(link => <li key={link.href} data-id="element-417" data-mp="2cubapuuozvek">
                  <a href={link.href} className="whitespace-nowrap text-[17px] font-medium text-ink transition-colors duration-150 hover:text-ink/55" data-id="element-418" data-mp="2cvcymzwt4cdp">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center gap-5" data-id="element-419" data-mp="30m8npp9voth9">
            <ul className="hidden items-center gap-3 sm:flex" data-id="element-420" data-mp="2vsxan6eh3ggw">
              {iconLinks.map(({
              label,
              href,
              external,
              icon
            }) => <li key={label} data-id="element-421" data-mp="ty9khluxoso8">
                  <a href={href} aria-label={label} title={label} {...external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="grid h-8 w-8 place-items-center text-tint transition-colors duration-150 hover:text-ink" data-id="element-422" data-mp="xy9zp8pux7wc">
                    {icon}
                  </a>
                </li>)}
            </ul>
            <button type="button" onClick={() => setMenuOpen(v => !v)} aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? 'Menü schließen' : 'Menü öffnen'} className="grid h-10 w-10 place-items-center border border-line lg:hidden" data-id="element-423" data-mp="f562xehceexi">
              {menuOpen ? <XIcon className="h-4 w-4" data-id="element-424" data-mp="20jajcfh3izaz" /> : <MenuIcon className="h-4 w-4" data-id="element-425" data-mp="20iixhwdawfxw" />}
            </button>
          </div>
        </nav>
      </div>

      <AnimatePresence data-id="element-426" data-mp="2am633esm4pet">
        {menuOpen && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-y border-line bg-white lg:hidden" data-id="element-427" data-mp="25qieb0i1ly9u">
            <ul className="px-4 py-2 md:px-6" data-id="element-428" data-mp="2tguvl1z6h7d3">
              {navLinks.map(link => <li key={link.href} className="border-b border-line last:border-b-0" data-id="element-429" data-mp="2oi1ihanszidg">
                  <a href={link.href} onClick={() => setMenuOpen(false)} className="flex items-center justify-between py-4 text-[17px] text-ink" data-id="element-430" data-mp="32ex03ri4ei54">
                    {link.label}
                    <span className="font-mono text-[11px] text-muted" data-id="element-431" data-mp="140vhd6gpcrql">{link.href}</span>
                  </a>
                </li>)}
              <li className="py-4" data-id="element-432" data-mp="15jdayabcqlrp">
                <a href="/#contact" onClick={() => setMenuOpen(false)} className="block bg-ink px-4 py-3 text-center text-[15px] font-medium text-white" data-id="element-433" data-mp="1afu97xc9mgii">
                  Kostenloses Angebot erhalten
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}